import scrollViewport from '../utils/scroll-viewport';
import lazyLoad from '../utils/lazy-load';

lazyLoad();

var $comFounded = $('#com-founded');
var $comPower = $('#com-power');
var $comCustomer = $('#com-customer');

scrollViewport('.screen', function($screen) {
  $screen.addClass('active').removeClass('disabled-animated');

  if ($screen.hasClass('introduction')) {
    var myDate = new Date();
    var year=myDate.getFullYear()-2009;
    $comFounded.html(year);
    $comPower.html('150');
    $comCustomer.html('50');
  }
}, {
  delayDistance: 50,
  onLeave: function($screen) {
    $screen.removeClass('active');

    if ($screen.hasClass('introduction')) {
      $comFounded.html('00');
      $comPower.html('00');
      $comCustomer.html('00');
    }
  }
});
// banner 轮播
$(function() {
  var $win = $(window);
  var winW = $win.width();
  // var $bannerWrap = $('.banner-wrap');
  var $banner = $('.banner');
  var $bannerItems = $('.banner .item');
  var bannerLen = $bannerItems.length;
  var autoSlide;
  var curIndex = 0;
  var $controls = $('.banner-wrap .banner-controls .item');

  sizeBanner();
  startAutoSlide();

  $win.on('resize', function() {
    sizeBanner();
  });

  $controls.on('click', function() {
    var index = $(this).index() || 0;
    slideTo(index);
  });

  $controls.on('mouseenter', stopAutoSlide);
  $controls.on('mouseleave', startAutoSlide);

  function startAutoSlide() {
    if (!autoSlide) {
      autoSlide = window.setInterval(slideItem, 5000);
    }
  }

  function stopAutoSlide() {
    if (autoSlide) {
      window.clearInterval(autoSlide);
      autoSlide = null;
    }
  }

  function sizeBanner() {
    winW = $win.width();
    $banner.width(winW * bannerLen);
    $bannerItems.width(winW);

    slideTo(curIndex);
  }

  function slideItem(direction = 1) {
    slideTo((curIndex + direction) % bannerLen);
  }

  function slideTo(index = 0) {
    curIndex = index;
    var posLeft = -index * winW;

    setControlActive(index);

    $banner.animate({ left: `${posLeft}px` }, function() {
      setBannerActive(index);
    });
  }

  function setControlActive(index = 0) {
    $controls.removeClass('active').eq(index).addClass('active');
  }

  function setBannerActive(index = 0) {
    $bannerItems.removeClass('active').eq(index).addClass('active');
  }


  // swiper
  initSwiper();

  function initSwiper() {
    // 合作客户
    var mySwiper = $('.customer-list-container').swiper({
      loop: true,
      slidesPerView: 7,
      onlyExternal: true,
      autoplay: 3000,
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    });

    console.log(mySwiper.slideNext);

    $('.customer-list').on('mouseleave', function() {
      mySwiper.startAutoplay();
    }).on('mouseenter', function() {
      mySwiper.stopAutoplay();
    }).on('click', '.prev', function() {
      mySwiper.swipePrev();
    }).on('click', '.next', function() {
      mySwiper.swipeNext();
    });
  }


});

initWiper();
function initWiper() {
  // 产品轮播
  var myWiper = $('.menu-block-item').swiper({
    loop: false,
    slidesPerView: 5,
    onlyExternal: true,
    autoplay: 3000,
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  });

  console.log(myWiper.slideNext);

  $('.menu-block').on('mouseleave', function() {
   myWiper.startAutoplay();
  }).on('mouseenter', function() {
   myWiper.stopAutoplay();
  }).on('click', '.prev1', function() {
   myWiper.swipePrev();
  }).on('click', '.next1', function() {
   myWiper.swipeNext();
  });
}


// WEBPACK FOOTER //
// ./src/js/index.js